// extracted by mini-css-extract-plugin
export default {"input":"common_input__ATGfG"};